export const css = {
    root: '_341iDHzq',
    content: '_3c971rMg',
    bottom: '_1XVpIvIh',
    top: '_2MUUR7Es',
    left: '_3KkpakM4',
    right: '_3E-vT0Qw',
    ' _key': 'ascm-theme/ascm/dojo/tooltip'
};
export default css;
